import { useQuery, useQueryClient } from '@tanstack/react-query';

export default () => {
  const queryClient = useQueryClient();
  const queryKey = ['modals'];

  const { data: modals } = useQuery({
    initialData: [],
    queryFn: () => queryClient.getQueryData(queryKey),
    queryKey,
  });

  const addModal = (modal) =>
    new Promise((resolve) => {
      Object.assign(modal, {
        id: modal.id ?? modal.model?.id ?? `modal-${modals.length}`,
        resolve,
      });

      queryClient.setQueryData(queryKey, [...modals, modal]);
    });

  const removeModal = ({ id: targetId, payload, type = 'CLOSE' } = {}) => {
    const modal = modals.find(({ id }) => id === targetId) || modals.at(-1);

    if (!modal) return;

    const modalId = modal.id;

    queryClient.setQueryData(
      queryKey,
      modals.filter(({ id }) => id !== modalId),
    );

    modal.resolve({ payload: payload || modal.model, type });
  };

  const getModel = (id) => modals.find((modal) => modal.id === id)?.model || {};

  const setModel = (id, model) => {
    queryClient.setQueryData(
      queryKey,
      modals.map((modal) => (modal.id === id ? { ...modal, model } : modal)),
    );
  };

  return {
    addModal,
    getModel,
    modals,
    removeModal,
    setModel,
  };
};
